import Query from './Query';

export default Query;
